import React, { useEffect, useState } from 'react';
import { DeepLinkDefaultLink, deepLinkLocalStoreUtil, getDeepLinkUri } from '../../utils/deepLinkUtils';
import AuthAxios from '../../axios';
import DeepLinkImage from '../../assets/deepLink/deepLinkImage.png';
import { useNavigate } from 'react-router-dom';

export default function DeepLinkGuidePage() {
  const [deepLinkUri, setDeepLinkUri] = useState(DeepLinkDefaultLink);
  const navigate = useNavigate();

  const fetchAndSetDeepLinkUri = async () => {
    const deepLinkId = deepLinkLocalStoreUtil();
    if (deepLinkId) {
      const deepLinkUri = await getDeepLinkUri(deepLinkId);
      if (deepLinkUri) {
        console.log('[Success] fetchAndSetDeepLinkUri ~ deepLinkUri:', deepLinkUri);
        setDeepLinkUri(deepLinkUri);
      } else {
        console.error('[Failed] fetchAndSetDeepLinkUri ~ deepLinkUri:', deepLinkUri);
      }
    } else {
      console.log('[NotFound] fetchAndSetDeepLinkUri ~ deepLinkId:', deepLinkId);
    }
  };

  const onClickDeepLinkUri = () => {
    deepLinkLocalStoreUtil({ isDelete: true });
    navigate('/app/home');
  };

  useEffect(() => {
    fetchAndSetDeepLinkUri();
  }, []);
  return (
    <div className="flex items-center flex-col flex-1 h-full bg-[#13171E] p-8 overflow-auto gap-8">
      <div className="flex-1 justify-center items-center flex flex-col">
        <h1
          className=" text-center mb-[50px] text-[24px] text-white font-[600]"
          style={{ lineHeight: '34px', letterSpacing: -0.6 }}
        >
          환영합니다!
        </h1>
        <div
          className="text-[16px] text-white text-center font-[500]"
          style={{ lineHeight: '24px', letterSpacing: -0.4 }}
        >
          <p>의료 전문 연구원들이</p>
          <p>3.5배 개선을 입증한 사운드필로</p>
          <p>일상을 바꾸세요.</p>
        </div>
        <img src={DeepLinkImage} className="pt-16" />
      </div>
      <div className="flex items-end w-full justify-center">
        <a
          href={deepLinkUri}
          onClick={onClickDeepLinkUri}
          className="text-white flex items-center justify-center px-4 py-4 gap-[10px] shrink-0 rounded-[50px] bg-[#4F68FC] w-full max-w-[335px] min-w-[100px] h-[60px]"
        >
          체험하기
        </a>
      </div>
    </div>
  );
}
